import "core-js/modules/web.dom-collections.iterator.js";
import * as React from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '../styles';
import Stack from "../Stack";
// type listOfPills = Array<Pick<ProgressPillProps, "numberOfPills">>

const BorderLinearProgress = styled(LinearProgress, {
  shouldForwardProp: prop => prop !== 'maxWidth'
})(_ref => {
  let {
    theme,
    maxWidth
  } = _ref;
  return {
    height: 4,
    width: 80,
    maxWidth,
    borderRadius: 0,
    flexGrow: 1,
    flexBasis: "auto",
    display: "flex",
    ["&.".concat(linearProgressClasses.colorPrimary)]: {
      backgroundColor: theme.palette.pixelContrast.shades.medium
    },
    ["& .".concat(linearProgressClasses.bar)]: {
      borderRadius: 0,
      backgroundColor: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light
    }
  };
});
const ProgressPill = _ref2 => {
  let {
    numberOfPills,
    selectedNumberOfPills,
    containerMaxWidth,
    maxWidth
  } = _ref2;
  const numberOfPillsKeyArray = Array.from(Array(numberOfPills).keys());
  const selectedNumberOfPillsKeyArray = Array.from(Array(selectedNumberOfPills).keys());
  const listOfPills = [...numberOfPillsKeyArray];
  const listOfSelectedPills = [...selectedNumberOfPillsKeyArray];
  return /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 1,
    style: {
      maxWidth: containerMaxWidth
    }
  }, listOfPills.map(pill => /*#__PURE__*/React.createElement(BorderLinearProgress, {
    key: "".concat(pill, "_pill"),
    variant: "determinate"
    // @ts-ignore
    ,
    maxWidth: maxWidth,
    value: listOfSelectedPills.includes(pill) ? 100 : 0
  })));
};
export default ProgressPill;